export default "__VITE_ASSET__DIQOTXde__"